import DefaultRoleEs from './DefaultRoleEs.json'
import DefaultRoleEn from './DefaultRoleEn.json'
import UsersWithoutRoleEs from './UsersWithoutRoleEs.json'
import UsersWithoutRoleEn from './UsersWithoutRoleEn.json'

export const config = {
  backend: {
    host: process.env.REACT_APP_HTTP_HOST,
    hostWs: process.env.REACT_APP_WS_HOST,
    wsProtocol: process.env.REACT_APP_WS_PROTOCOL,
    portHttp: process.env.REACT_APP_HTTP_PORT,
    portWs: process.env.REACT_APP_HTTP_PORTWS,
    httpHostBackendFile: process.env.REACT_APP_HTTPHOSTBACKEND,
    httpPortBackendFile: process.env.REACT_APP_HTTPPORTBACKEND,
    basePath: process.env.REACT_APP_BASE_PATH,
    language: process.env.REACT_APP_LANGUAGE,
    ProjectStartDate: process.env.REACT_APP_PROJECT_START_DATE
  },
  app: {
    develop: process.env.REACT_APP_DEVELOP
  },
  map: {
    center: JSON.parse(process.env.REACT_APP_LOCATION_MAP),
    zoom_general: process.env.REACT_APP_MAP_ZOOM_GENERAL,
    zoom_specific: process.env.REACT_APP_MAP_ZOOM_SPECIFIC,
    api_key: process.env.REACT_APP_GEOSEARCH_KEY
  },
  restore: {
    hash: 'o6PBmJwBGLO;t12'
  },
  defaultRoleEs: DefaultRoleEs,
  defaultRoleEn: DefaultRoleEn,
  usersWithoutRoleEs: UsersWithoutRoleEs,
  usersWithoutRoleEn: UsersWithoutRoleEn
}
